<script setup lang="ts">
defineProps({
  isShow: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

defineEmits<{
  (e: 'onClose'): void
  (e: 'onConfirm', password: string): void
}>();

const password = ref('');
</script>

<template>
  <ConfirmDialog
    confirm-button-name="Proceed"
    cancel-button-name="Cancel"
    :is-show="isShow"
    :is-loading="isLoading"
    :disabled-confirm="!password"
    persistent
    @on-close="$emit('onClose')"
    @on-confirm="$emit('onConfirm', password)"
    @keyup.enter="$emit('onConfirm', password)"
  >
    <template #header>
      <AlertCircleIcon
        class="icon-header-confirm-dlg icon-info"
        :color="ICON_COLOR.PRIMARY"
      />
    </template>
    <template #title>
      <h1 class="dialog-title text-lg text-semibold">
        This event is password protected.
      </h1>
    </template>
    <template #content>
      <div class="password-protected-content">
        <p class="text-sm text-regular">
          Please enter the password.
        </p>
        <BaseTextInput
          v-model="password"
          type="password"
          placeholder="Password"
        />
      </div>
    </template>
  </ConfirmDialog>
</template>

<style lang="scss" scoped>
.password-protected-content {
  display: flex;
  flex-direction: column;
  row-gap: spacings-get(2);
  padding-top: spacings-get(2);
}
</style>